import format from 'date-fns/format';
import { utcToZonedTime } from 'date-fns-tz';
import { SERVER_TIME_ZONE } from '../../../util/config';

export const formatDate = (date: number | undefined) => {
  if (!date) {
    return '';
  }
  return format(utcToZonedTime(date, SERVER_TIME_ZONE), 'MM/dd/yyyy');
};
